const requiredFieldsSix = ["autobiography"];

export default requiredFieldsSix;
